import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59271590"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow" }
const _hoisted_2 = { class: "flex h-full seekaBrandSetupRequest bg-background" }
const _hoisted_3 = { class: "flex w-full md:flex-row flex-col" }
const _hoisted_4 = { class: "flex w-full flex-col justify-center px-4 xs:px-2 md:px-6 lg:w-1/2 lg:px-20 xl:px-24" }
const _hoisted_5 = { class: "mx-auto w-full max-w-md" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "px-16 mt-10 md:mt-0 w-auto",
        src: "https://assets.oztix.com.au/file/de9cbca1-8f30-4aa0-bab7-fbc5c75067a4=seeka-logo-white.svg",
        alt: "Seeka"
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mt-6" }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "flex h-7 mr-2 self-center mb-0.5",
          src: "https://oztix.link/x27g1y",
          alt: "Oztix"
        }),
        /*#__PURE__*/_createElementVNode("h2", { class: "flex text-2xl font-bold leading-9 tracking-tight text-50 text-end" }, " Brand Setup Request ")
      ])
    ])
  ])
], -1))
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = { class: "form__group relative flex-1" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "block text-sm font-medium leading-6 form__label mt-4",
  for: "EventVenueName"
}, " What is the name of your Festival, Event, or Venue? ", -1))
const _hoisted_11 = { class: "form__group relative" }
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "block text-sm font-medium leading-6 form__label mt-4",
  for: "BillingEntityName"
}, " What is your billing entity's name and email? ", -1))
const _hoisted_14 = { class: "email-input-group mt-2 flex items-center" }
const _hoisted_15 = { class: "form__group relative" }
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "block text-sm font-medium leading-6 form__label mt-4",
  for: "AdditionalBrandUsers"
}, " Who would you like added to your brand? ", -1))
const _hoisted_18 = { class: "flex flex-row w-full" }
const _hoisted_19 = ["id", "onUpdate:modelValue"]
const _hoisted_20 = ["id", "onUpdate:modelValue"]
const _hoisted_21 = { class: "flex flex-row w-full" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "mt-6 flex justify-center" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "mt-4 text-center"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hidden md:flex md:flex-col md:w-full 3xl:before:from-background 3xl:before:to-popover bg-white 3xl:bg-[url('https://assets.oztix.com.au/image/bd23ce9f-ae46-4744-b518-7fa53b759f87.png?width=1000')] 3xl:relative 3xl:z-10 w-full 3xl:bg-cover 3xl:bg-center 3xl:bg-no-repeat 3xl:before:absolute 3xl:before:inset-0 before:z-[-5] before:block 3xl:before:bg-gradient-to-r 3xl:before:opacity-70 3xl:before:content-[''] lg:block lg:w-1/2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-center h-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mx-auto" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full h-full md:mx-auto 2xl:mx-auto xl:max-w-2xl 2xl:max-w-3xl 3xl:max-w-5xl my-auto space-y-4" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "rounded-none 3xl:rounded-md my-2 2xl:my-8 3xl:my-16 w-full px-4 py-4 2xl:py-8 bg-white" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mx-2 md:mx-8 xl:mx-10 2xl:mx-16 justify-between items-start" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "w-full mb-8 md:mb-0 pr-2" }, [
              /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl xl:text-3xl font-bold text-brand-500 mb-2 md:mb-3 xl:mb-5" }, " Pricing "),
              /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-auto pr-5 mb-8 md:mb-0" }, [
                /*#__PURE__*/_createElementVNode("p", { class: "text-base text-black mb-1 xl:mb-2" }, "Oztix customers wanting to sign up to Seeka have unique pricing built exclusively for the entertainment industry's dynamic nature including a free 7 Day Trial or 30K sessions (whichever comes first). ")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "rounded-lg shadow-md p-3 mx-1" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-center" }, [
                    /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-semibold text-brand-500 mb-2" }, " OZTIX SEASONAL PRO ")
                  ]),
                  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col xl:flex-row" }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "flex items-baseline mb-2" }, [
                        /*#__PURE__*/_createElementVNode("span", { class: "text-4xl font-bold text-brand-500" }, "$29"),
                        /*#__PURE__*/_createElementVNode("span", { class: "text-xl text-gray-600 ml-2" }, "/Month")
                      ]),
                      /*#__PURE__*/_createElementVNode("p", { class: "text-brand-500 font-bold mb-4" }, "Access and data retention"),
                      /*#__PURE__*/_createElementVNode("p", { class: "text-brand-500 font-semibold" }, "+ $0.006 a session ")
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col sm:ml-2 justify-end" }, [
                      /*#__PURE__*/_createElementVNode("ul", { class: "mt-2 xl:mt-0 text-sm" }, [
                        /*#__PURE__*/_createElementVNode("li", { class: "flex items-center text-black mb-2" }, [
                          /*#__PURE__*/_createElementVNode("svg", {
                            class: "w-5 h-5 text-green-500 mr-2",
                            fill: "currentColor",
                            viewBox: "0 0 20 20"
                          }, [
                            /*#__PURE__*/_createElementVNode("path", { d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" })
                          ]),
                          /*#__PURE__*/_createTextVNode(" Unlimited data sources ")
                        ]),
                        /*#__PURE__*/_createElementVNode("li", { class: "flex items-center text-black mb-2" }, [
                          /*#__PURE__*/_createElementVNode("svg", {
                            class: "w-5 h-5 text-green-500 mr-2",
                            fill: "currentColor",
                            viewBox: "0 0 20 20"
                          }, [
                            /*#__PURE__*/_createElementVNode("path", { d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" })
                          ]),
                          /*#__PURE__*/_createTextVNode(" Connect unlimited platforms ")
                        ]),
                        /*#__PURE__*/_createElementVNode("li", { class: "flex items-center text-black mb-2" }, [
                          /*#__PURE__*/_createElementVNode("svg", {
                            class: "w-5 h-5 text-green-500 mr-2",
                            fill: "currentColor",
                            viewBox: "0 0 20 20"
                          }, [
                            /*#__PURE__*/_createElementVNode("path", { d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" })
                          ]),
                          /*#__PURE__*/_createTextVNode(" Access to Oztix identity graph ")
                        ]),
                        /*#__PURE__*/_createElementVNode("li", { class: "flex items-center text-black" }, [
                          /*#__PURE__*/_createElementVNode("svg", {
                            class: "w-5 h-5 text-green-500 mr-2",
                            fill: "currentColor",
                            viewBox: "0 0 20 20"
                          }, [
                            /*#__PURE__*/_createElementVNode("path", { d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" })
                          ]),
                          /*#__PURE__*/_createTextVNode(" Access to all future features ")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "w-full pl-3" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://assets.oztix.com.au/image/6a993b33-e15c-4f9a-bab7-ccfd337c8238.png",
                  alt: "Crowd with checkmarks",
                  class: "w-full max-w-md mx-auto"
                })
              ]),
              /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl text-brand-500 font-bold mb-4 mt-2" }, "What you get "),
              /*#__PURE__*/_createElementVNode("ul", { class: "space-y-2 list-disc text-sm xl:text-base" }, [
                /*#__PURE__*/_createElementVNode("li", { class: "text-black" }, [
                  /*#__PURE__*/_createElementVNode("span", null, "Just $29/month for access to Seeka and data retention, plus $0.006 per session used.")
                ]),
                /*#__PURE__*/_createElementVNode("li", { class: "text-black" }, [
                  /*#__PURE__*/_createElementVNode("span", null, "A session is counted each time a user visits your website with unlimited page views per session.")
                ]),
                /*#__PURE__*/_createElementVNode("li", { class: "text-black" }, [
                  /*#__PURE__*/_createElementVNode("span", null, "Connect unlimited ad platforms such as Meta™, Google™, TikTok™, Snapchat™, and Pinterest™, plus unlimited data sources such as ticketing outlets, websites, and pre-registration platforms.")
                ]),
                /*#__PURE__*/_createElementVNode("li", { class: "text-black" }, [
                  /*#__PURE__*/_createElementVNode("span", null, "Harness the power of the Oztix identity graph for enhanced ad performance.")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "flex mt-8 px-auto w-full justify-center" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  href: "https://tktrev.com/Seeka_OztixExplainer",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  alt: "Explainer Video",
                  class: "flex text-1xl text-brand-500 font-bold !outline-none !shadow-none"
                }, "Learn more about Seeka x Oztix here")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:hidden flex flex-row justify-center w-full mt-14" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "md:hidden flex flex-col w-full h-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-full px-4 xs:px-2 py-5 bg-white" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-between items-start" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-2/4 mb-8 md:mb-0" }, [
          /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold text-brand-500 mb-3" }, "Pricing"),
          /*#__PURE__*/_createElementVNode("div", { class: "w-full pr-5 mb-8 md:mb-0" }, [
            /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-black mb-3" }, "Oztix customers wanting to sign up to Seeka have unique pricing built exclusively for the entertainment industry's dynamic nature including a free 7 Day Trial or 30K sessions (whichever comes first). ")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "rounded-lg shadow-md p-5 mx-2" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-center" }, [
                /*#__PURE__*/_createElementVNode("h2", { class: "text-xl sm:text-2xl font-semibold text-brand-500 mb-4" }, " OZTIX SEASONAL PRO ")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col sm:flex-row" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "flex items-baseline mb-4" }, [
                    /*#__PURE__*/_createElementVNode("span", { class: "text-4xl font-bold text-brand-500" }, "$29"),
                    /*#__PURE__*/_createElementVNode("span", { class: "text-xl text-gray-600 ml-2" }, "/Month")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", { class: "text-brand-500 font-bold mb-4" }, "Access and data retention"),
                  /*#__PURE__*/_createElementVNode("p", { class: "text-brand-500 font-semibold" }, "+ $0.006 a session ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col sm:ml-2 justify-end" }, [
                  /*#__PURE__*/_createElementVNode("ul", { class: "mt-6 text-sm" }, [
                    /*#__PURE__*/_createElementVNode("li", { class: "flex items-center text-black mb-2" }, [
                      /*#__PURE__*/_createElementVNode("svg", {
                        class: "w-5 h-5 text-green-500 mr-2",
                        fill: "currentColor",
                        viewBox: "0 0 20 20"
                      }, [
                        /*#__PURE__*/_createElementVNode("path", { d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" })
                      ]),
                      /*#__PURE__*/_createTextVNode(" Unlimited data sources ")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", { class: "flex items-center text-black mb-2" }, [
                      /*#__PURE__*/_createElementVNode("svg", {
                        class: "w-5 h-5 text-green-500 mr-2",
                        fill: "currentColor",
                        viewBox: "0 0 20 20"
                      }, [
                        /*#__PURE__*/_createElementVNode("path", { d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" })
                      ]),
                      /*#__PURE__*/_createTextVNode(" Connect unlimited platforms ")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", { class: "flex items-center text-black mb-2" }, [
                      /*#__PURE__*/_createElementVNode("svg", {
                        class: "w-5 h-5 text-green-500 mr-2",
                        fill: "currentColor",
                        viewBox: "0 0 20 20"
                      }, [
                        /*#__PURE__*/_createElementVNode("path", { d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" })
                      ]),
                      /*#__PURE__*/_createTextVNode(" Access to Oztix identity graph ")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", { class: "flex items-center text-black" }, [
                      /*#__PURE__*/_createElementVNode("svg", {
                        class: "w-5 h-5 text-green-500 mr-2",
                        fill: "currentColor",
                        viewBox: "0 0 20 20"
                      }, [
                        /*#__PURE__*/_createElementVNode("path", { d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" })
                      ]),
                      /*#__PURE__*/_createTextVNode(" Access to all future features ")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/2" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "mt-0.5" }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: "https://assets.oztix.com.au/image/d7f2938f-39f3-4857-9801-bc28b9d6c59f.png",
              alt: "Crowd with checkmarks",
              class: "w-full max-w-md mx-auto"
            })
          ]),
          /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl text-brand-500 font-bold mb-4" }, "What you get"),
          /*#__PURE__*/_createElementVNode("ul", { class: "space-y-4 list-disc ml-5" }, [
            /*#__PURE__*/_createElementVNode("li", { class: "text-black" }, [
              /*#__PURE__*/_createElementVNode("span", null, "Just $29/month for access to Seeka and data retention, plus $0.006 per session used.")
            ]),
            /*#__PURE__*/_createElementVNode("li", { class: "text-black" }, [
              /*#__PURE__*/_createElementVNode("span", null, "A session is counted each time a user visits your website with unlimited page views per session.")
            ]),
            /*#__PURE__*/_createElementVNode("li", { class: "text-black" }, [
              /*#__PURE__*/_createElementVNode("span", null, "Connect unlimited ad platforms such as Meta™, Google™, TikTok™, Snapchat™, and Pinterest™, plus unlimited data sources such as ticketing outlets, websites, and pre-registration platforms.")
            ]),
            /*#__PURE__*/_createElementVNode("li", { class: "text-black" }, [
              /*#__PURE__*/_createElementVNode("span", null, "Harness the power of the Oztix identity graph for enhanced ad performance.")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "flex mt-4 px-auto w-full justify-center" }, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "https://tktrev.com/Seeka_OztixExplainer",
              target: "_blank",
              rel: "noopener noreferrer",
              alt: "Explainer Video",
              class: "flex text-1xl text-brand-500 font-bold !outline-none !shadow-none"
            }, "Learn more about Seeka x Oztix here")
          ])
        ])
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_compact_layout = _resolveComponent("compact-layout")!

  return (_openBlock(), _createBlock(_component_compact_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("form", {
                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitSeekaBrandSetupRequest && _ctx.submitSeekaBrandSetupRequest(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.SeekaBrandSetupRequest.eventVenueName) = $event)),
                          autocomplete: "off",
                          class: "border-border bg-background text-foreground ring-offset-background placeholder-muted-foreground focus-visible:!ring-ring mt-2 flex h-10 w-full rounded-md border px-3 py-2 text-sm focus-visible:!outline-none focus-visible:!ring-2 hover:border-brand-500 form__control autofill:bg-background autofill:text-foreground autofill:border-border",
                          id: "EventVenueName",
                          maxlength: "100",
                          name: "EventVenueName",
                          type: "text",
                          autofocus: "autofocus",
                          placeholder: "Name of Festival / Event / Venue",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.SeekaBrandSetupRequest.eventVenueName]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.SeekaBrandSetupRequest.entityName) = $event)),
                            autocomplete: "off",
                            class: "border-border bg-background text-foreground ring-offset-background placeholder-muted-foreground focus-visible:!ring-ring flex h-10 w-1/2 rounded-md border px-3 py-2 text-sm focus-visible:!outline-none focus-visible:!ring-2 hover:border-brand-500 form__control autofill:bg-background autofill:text-foreground autofill:border-border",
                            id: "BillingEntityName",
                            maxlength: "100",
                            name: "BillingEntityName",
                            type: "text",
                            placeholder: "Billing Name",
                            required: ""
                          }, null, 512), [
                            [_vModelText, _ctx.SeekaBrandSetupRequest.entityName]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.SeekaBrandSetupRequest.email) = $event)),
                            autocomplete: "off",
                            class: "border-border bg-background text-foreground ring-offset-background placeholder-muted-foreground focus-visible:!ring-ring flex h-10 w-1/2 rounded-md border px-3 py-2 text-sm focus-visible:!outline-none focus-visible:!ring-2 hover:border-brand-500 form__control autofill:bg-background autofill:text-foreground autofill:border-border ml-2",
                            id: "Email",
                            maxlength: "100",
                            name: "Email",
                            type: "email",
                            placeholder: "Billing Email",
                            required: ""
                          }, null, 512), [
                            [_vModelText, _ctx.SeekaBrandSetupRequest.email]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalBrandUsers, (entry, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "email-input-group mt-2 flex flex-col items-center"
                          }, [
                            _createElementVNode("div", _hoisted_18, [
                              _withDirectives(_createElementVNode("input", {
                                id: 'name-' + index,
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((entry.name) = $event),
                                autocomplete: "off",
                                class: "border-border bg-background text-foreground ring-offset-background placeholder-muted-foreground focus-visible:!ring-ring flex h-10 w-1/2 rounded-md border px-3 py-2 text-sm focus-visible:!outline-none focus-visible:!ring-2 hover:border-brand-500 form__control autofill:bg-background autofill:text-foreground autofill:border-border",
                                placeholder: "Brand User - Name"
                              }, null, 8, _hoisted_19), [
                                [_vModelText, entry.name]
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                id: 'email-' + index,
                                type: "email",
                                "onUpdate:modelValue": ($event: any) => ((entry.email) = $event),
                                autocomplete: "off",
                                class: "border-border bg-background text-foreground ring-offset-background placeholder-muted-foreground focus-visible:!ring-ring flex h-10 w-1/2 rounded-md border px-3 py-2 text-sm focus-visible:!outline-none focus-visible:!ring-2 hover:border-brand-500 form__control autofill:bg-background autofill:text-foreground autofill:border-border ml-2",
                                placeholder: "Brand User - Email"
                              }, null, 8, _hoisted_20), [
                                [_vModelText, entry.email]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              (_ctx.isRemoveButtonVisible())
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: _withModifiers(($event: any) => (_ctx.removeAdditionalBrandUser(index)), ["prevent"]),
                                    class: "flex py-1 text-sm text-orange-400 !outline-none !shadow-none"
                                  }, " remove ", 8, _hoisted_22))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("button", {
                          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addAdditionalBrandUser && _ctx.addAdditionalBrandUser(...args)), ["prevent"])),
                          class: "mt-2 text-sm text-brand-500 font-semibold !outline-none !shadow-none"
                        }, " Add Brand User ")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("button", {
                        class: "button-shadow bg-brand-500 hover:bg-brand-600 active:bg-brand-600 focus-visible:!outline-brand-200 flex w-80 justify-center rounded-md px-6 py-2 font-semibold leading-6 focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2",
                        type: "submit",
                        disabled: _ctx.isSubmitting
                      }, _toDisplayString(_ctx.getSubmitButtonText()), 9, _hoisted_24)
                    ]),
                    (_ctx.responseMessage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("p", {
                            class: _normalizeClass(_ctx.responseClass)
                          }, _toDisplayString(_ctx.responseMessage), 3)
                        ]))
                      : _createCommentVNode("", true)
                  ], 32)
                ])
              ])
            ]),
            _hoisted_26,
            _hoisted_27
          ])
        ])
      ])
    ]),
    _: 1
  }))
}